import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

// components
import { Box, Button, Typography } from '@mui/material'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'

import styles from './subHeaderActions.module.scss'

const SubHeaderActions = ({
  groupName,
}) => {
  const navigate = useNavigate()
  const { groupId } = useParams()
  const { t } = useTranslation()

  const handleGoBack = () => {
    navigate(`/view-group/${groupId}`)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        marginTop: '40px',
        marginBottom: '30px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        gap: '8px',
      }}
    >
      <Button
        className={styles.goBackBtn}
        startIcon={<ArrowBackIosIcon />}
        onClick={handleGoBack}
      >
        {t('edit-members-back-to-group-details')}
      </Button>
      <Typography variant="h3" className={styles.subHeaderTitle}>
        {t('edit-members-sub-header-title')}
      </Typography>
      <Typography variant="body1" className={styles.subHeaderText}>
        {`${t('edit-members-modal-group-name')} ${groupName}`}
      </Typography>
    </Box>
  )
}

SubHeaderActions.propTypes = {
  groupName: PropTypes.string,
}

SubHeaderActions.defaultProps = {
  groupName: '',
}

export default SubHeaderActions
